import BootstrapField from '../utility/BootstrapField';
import moment from 'moment-timezone';
// import CloneDeep from 'lodash.clonedeep';
import RestrictionBlockRestriction from '../models/RestrictionBlockRestriction';
import Format from '../utility/Format';


// As private as it gets.
// let originalRestrictionBlockData = null;

export default class RestrictionBlock {
	constructor(data) {
		if (!data) {
			data = {};
		}
		if (data.useTestData) {
			data = {
			}

		}

		Object.assign(this, {
			blockId: data.blockId || null,
			streetName: new BootstrapField({
				value: data.streetName || null,
				required: true,
			}),
			fromStreet: new BootstrapField({
				value: data.fromStreet || null,
				required: true,
			}),
			toStreet: new BootstrapField({
				value: data.toStreet || null,
				required: true,
			}),
			kml: data.kml||null,
			lanesClosedSameTime: new BootstrapField({
				value: data.lanesClosedSameTime || null,
				required: true,
			}),
			trafficSignalsAltered: new BootstrapField({
				value:  typeof data.trafficSignalsAltered === 'number' ? data.trafficSignalsAltered:  null,
			}),

			mapPolyline:null,

			// list of LCR restrictions
			// each restriction contains:  direction, type of restriction, cross street name, restrictionPeakId, peakReason
			restriction:[],

		});

		if (data.restriction instanceof Array) {
			let x = 0;
			for (x =0; x < data.restriction.length; x++) {
				this.restriction.push(new RestrictionBlockRestriction(data.restriction[x]));
			}
		}


		// Keep a record of the old data. (used for the hasChanges() method)
		// originalRestrictionBlockData = CloneDeep(this);
	}

	validate() {

		this.toTime.invalidMessage = 'Please enter a valid end time';
		this.toDate.invalidMessage = 'Please enter a valid estimated completion date';
		let flag = true;

		let errors = [];


		for (let field in this) {
			if (this[field] instanceof BootstrapField) {
				let result = this[field].validate();
				if (result === false) {
					errors.push(field);
					flag = false;
				}
			}
		}

		// Check if the end time is earlier than start time
		if (this.toDate.validate() == null && this.fromDate.validate() == null && this.toTime.validate() == null && this.fromTime.validate() == null) {
			if (Format.fromUtc(this.fromDate.value).isSame(Format.fromUtc(this.toDate.value), 'day')) {
				// let startTime = this.fromTime.value;
				// let endTime = this.toTime.value;

				// let start = new Date();
				// start.setHours(startTime.a == 'pm' ? startTime.h + 12 : startTime.h);
				// start.setMinutes(startTime.mm);
				// start.setSeconds(0);

				// let end = new Date();
				// end.setHours(endTime.a == 'pm' ? endTime.h + 12 : endTime.h);
				// end.setMinutes(endTime.mm);
				// end.setSeconds(0);

				// if (start.getTime() >= end.getTime()) {
				//     this.toTime.invalidMessage = 'Estimated completion time cannot be earlier than requested start time';
				//     this.toTime.status = false;
				// }

				let startTime = moment(this.fromTime.getValue(), 'h:mm a');
				let endTime = moment(this.toTime.getValue(), 'h:mm a');

				if (startTime.isSameOrAfter(endTime)) {
					this.toTime.invalidMessage = 'Estimated completion time cannot be earlier than requested start time';
					this.toTime.status = false;
					flag = false;
				}


			}
			// Check if end date is earlier than start date
			else if (Format.fromUtc(this.fromDate.value).isAfter(Format.fromUtc(this.toDate.value), 'day')) {
				this.toDate.invalidMessage = 'Estimated completion date cannot be earlier than requested start date';
				this.toDate.status = false;
				flag = false;
			}

		}
		return flag;
	}

	getRawValue() {
		return getRawValue(this);
		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			}
			else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							if (typeof obj[key][arrKey] != "function") {
								value[key].push(getRawValue(obj[key][arrKey]));
							}
						}
					}
					else {
						if (key == "mapPolyline") {
							value[key] = null;
						} else {
							if (typeof value[key] != "function") {
								value[key] = getRawValue(obj[key]);
							}
						}
					}
				}
			}
			else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

	getValue() {
		return getValue(this);
		function getValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getValue();
			}
			else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getValue(obj[key][arrKey]));
						}
					}
					else {
						value[key] = getValue(obj[key]);
					}
				}
			}
			else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				if (typeof obj == "function") {
					return null;
				} else {
					value = obj;
				}
			}
			return value;
		}
	}


	hasChanges() {

		// var differences = DeepDiff.diff(originalRestrictionBlockData.getRawValue(),  this.getRawValue());

		// return !IsEqual(originalRestrictionBlockData.getRawValue(), this.getRawValue());
		return false;
	}
	revertChanges() {
		// this.constructor(originalRestrictionBlockData);
	}
	saveChanges() {
		// originalRestrictionBlockData = CloneDeep(this);
	}
}